function BookshelfTitle({ title }) {
    return (
        <div className="bookshelf__title">{title}</div>
    )
}
export default BookshelfTitle